export default __webpack_public_path__ + "static/media/8.812961db.png";